/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreateBlueprintDetails {
    getFixupPrototypeFunction() { return CreateBlueprintDetails.fixupPrototype; }

    static newInstance(model: Partial<CreateBlueprintDetails>): CreateBlueprintDetails {
        let obj = Object.assign(new CreateBlueprintDetails(), model);
        CreateBlueprintDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreateBlueprintDetails>): CreateBlueprintDetails {
        if (!model) return null;
        return CreateBlueprintDetails.newInstance(<CreateBlueprintDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreateBlueprintDetails) {
        if (!obj) return;

        models.CreateBlueprintDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreateBlueprintDetails): boolean {
        Object.setPrototypeOf(obj, CreateBlueprintDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Blueprint ID
     */
    blueprint_id: string;

}
